import React, { useState } from "react";
import { Alert, Button, Container, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { unsubscribeFromNewsletter } from "../../actions/newsletterActions";

export default function NewsletterUnsubscribeScreen() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [state, setState] = useState({
    loading: false,
    error: token ? "" : "This unsubscribe link is incomplete.",
    message: "",
  });

  const unsubscribe = async () => {
    if (!token || state.loading || state.message) return;

    setState({ loading: true, error: "", message: "" });

    try {
      const result = await dispatch(unsubscribeFromNewsletter(token));
      setState({
        loading: false,
        error: "",
        message: result?.message || "You have been unsubscribed.",
      });
    } catch (error) {
      setState({
        loading: false,
        error: error?.message || "We could not unsubscribe you right now.",
        message: "",
      });
    }
  };

  return (
    <Container className="py-5" style={{ maxWidth: 720 }}>
      <h1>Newsletter preferences</h1>

      {!state.message && token ? (
        <p className="mt-3">
          Confirm that you no longer want to receive Academy Costumes
          marketing emails.
        </p>
      ) : null}

      {state.loading ? (
        <div className="d-flex align-items-center gap-2 mt-4">
          <Spinner animation="border" size="sm" />
          <span>Updating your subscription...</span>
        </div>
      ) : null}

      {state.message ? (
        <Alert variant="success" className="mt-4">
          {state.message}
        </Alert>
      ) : null}

      {state.error ? (
        <Alert variant="danger" className="mt-4">
          {state.error}
        </Alert>
      ) : null}

      {!state.message && token ? (
        <Button
          type="button"
          variant="dark"
          className="mt-3"
          disabled={state.loading}
          onClick={unsubscribe}
        >
          Unsubscribe
        </Button>
      ) : null}
    </Container>
  );
}
